import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excludeFrom',
})
export class ExcludeFromPipe implements PipeTransform {
  transform(inputArray: any[], filterCriteria: string): any[] {
    const filtered = [];

    if (filterCriteria == 'selected') {
      inputArray.forEach(val => {
        if (val.IsSelected) filtered.push(val);
      });
    } else if (filterCriteria == '!selected') {
      inputArray.forEach(val => {
        if (!val.IsSelected) filtered.push(val);
      });
    }
    return filtered;
  }
}
